import FormBankAccount from './FormBankAccount';

export default FormBankAccount;
